import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/svg/placer.svg'
import _imports_1 from '@/assets/svg/popup.svg'


const _hoisted_1 = {
  key: 0,
  class: "box"
}
const _hoisted_2 = { class: "d-flex flex-row align-items-center mb-2" }
const _hoisted_3 = { class: "NKT-P1-medium ms-2 mb-0" }
const _hoisted_4 = { class: "NKT-P1 ms-2 mb-0 ms-grey" }
const _hoisted_5 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_6 = { class: "flex-item" }
const _hoisted_7 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_8 = { class: "flex-item" }
const _hoisted_9 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_10 = { class: "flex-item" }
const _hoisted_11 = { class: "d-flex flex-row mt-3" }
const _hoisted_12 = { class: "active-alarms mb-0" }
const _hoisted_13 = {
  key: 1,
  class: "box"
}
const _hoisted_14 = { class: "d-flex flex-row align-items-center mb-3" }
const _hoisted_15 = { class: "NKT-P1-medium ms-2 mb-0" }
const _hoisted_16 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_21 = { class: "flex-item" }
const _hoisted_22 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_23 = { class: "flex-item" }
const _hoisted_24 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_25 = { class: "flex-item" }
const _hoisted_26 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_27 = { class: "flex-item" }
const _hoisted_28 = { class: "NKT-P1 w-100 sensor-rows" }
const _hoisted_29 = { class: "flex-item" }
const _hoisted_30 = {
  key: 2,
  class: "box"
}

import {
  CableVessel,
  VesselClient,
  VesselInfo,
  VesselInfoRequest
} from '@/server/MakeSenseApp-backend'
import { usePopupStore } from '@/stores/PopupStore'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'
import { computed, nextTick, ref, watch } from 'vue'
import DataLoading from '../general/loading/DataLoading.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
  cableLength: Number
},
  setup(__props) {

const popupStore = usePopupStore()
const projectStore = useProjectStore()



var client = requiredInject<VesselClient>('VesselClient')

const isVisible = computed(() => popupStore.isActive)

const showCabel = computed(() => popupStore.showCabel)

const showVessel = computed(() => popupStore.showVessel)
const vesselData = computed(() => popupStore.vesselData)

const vesselInfo = ref<VesselInfo | undefined>(undefined)

const popupHeight = computed(() => {
  return showCabel.value ? '160px' : showVessel.value ? '225px' : 'auto'
})

watch(vesselData, (newValue: CableVessel | undefined) => {
  vesselInfo.value = undefined

  if (newValue !== undefined) {
    client
      .vesselInfo(
        projectStore.projectId,
        new VesselInfoRequest({
          mmsi: newValue?.mmsi,
          timestamp: newValue.timestamp
        })
      )
      .then((response) => {
        vesselInfo.value = response
      })
  }
})

function closePopup() {
  popupStore.closePopup()
}

// watch to focus on the popup when it becomes visible
watch(isVisible, () => {
  if (isVisible.value) {
    nextTick(() => {
      const popupElement = document.getElementById('popup')
      popupElement?.focus()
    })
  }
})

const das = computed(() => popupStore.das)
const dts = computed(() => popupStore.dts)
const doB = computed(() => popupStore.doB)
const kp = computed(() => popupStore.kp)
const noOfAlarms = computed(() => popupStore.alarms!.length)
const formattedDoB = ref('')
const formattedDts = ref('')

watch(
  () => [doB.value, dts.value],
  ([newDoB, newDts]) => {
    formattedDoB.value = newDoB != null ? newDoB.toFixed(2) : ''
    formattedDts.value = newDts != null ? newDts.toFixed(2) : ''
  }
)

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onBlur: closePopup,
        tabindex: "0",
        class: "d-flex flex-column popup mb-2",
        style: _normalizeStyle({ height: popupHeight.value })
      }, [
        (showCabel.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("img", {
                  src: _imports_0,
                  class: "icon"
                }, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "NKT-P1-medium ms-2 mb-0" }, "Kilometer Point:", -1)),
                _createElementVNode("p", _hoisted_3, _toDisplayString(kp.value.toFixed(2)), 1),
                _createElementVNode("p", _hoisted_4, "(" + _toDisplayString(__props.cableLength?.toFixed(2)) + " km)", 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-item" }, "DoB:", -1)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(formattedDoB.value) + " m", 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-item" }, "Average temp:", -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString(formattedDts.value) + "°", 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-item" }, "DAS:", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(das.value) + " dB", 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(noOfAlarms.value) + " active alarms.", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (showVessel.value && vesselInfo.value !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: _imports_0,
                  class: "icon"
                }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "NKT-P1-medium ms-2 mb-0" }, "Position:", -1)),
                _createElementVNode("p", _hoisted_15, _toDisplayString(vesselInfo.value?.latitude?.toFixed(2)) + ", " + _toDisplayString(vesselInfo.value?.longitude?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-item" }, "Name:", -1)),
                _createElementVNode("div", {
                  class: "flex-item truncate",
                  title: vesselInfo.value?.vesselTypeName
                }, _toDisplayString(vesselInfo.value?.vesselName), 9, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-item" }, "Type:", -1)),
                _createElementVNode("div", {
                  class: "flex-item truncate",
                  title: vesselInfo.value?.vesselTypeName
                }, _toDisplayString(vesselInfo.value?.vesselTypeName), 9, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-item" }, "MMSI:", -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(vesselInfo.value?.mmsi), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-item" }, "Speed Over Ground:", -1)),
                _createElementVNode("div", _hoisted_23, _toDisplayString(vesselInfo.value?.speedOverGround?.toFixed(2) ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex-item" }, "Course Over Ground:", -1)),
                _createElementVNode("div", _hoisted_25, _toDisplayString(vesselInfo.value?.courseOverGround?.toFixed(2) ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-item" }, "Radio Call Signal:", -1)),
                _createElementVNode("div", _hoisted_27, _toDisplayString(vesselInfo.value?.radioCallSign), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex-item" }, "Destination:", -1)),
                _createElementVNode("div", _hoisted_29, _toDisplayString(vesselInfo.value?.destination?.trim() ? vesselInfo.value.destination : 'Not known'), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (showVessel.value && vesselInfo.value === undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(DataLoading)
            ]))
          : _createCommentVNode("", true),
        _cache[14] || (_cache[14] = _createElementVNode("img", {
          class: "icon pop-up-icon",
          id: "popup-icon",
          src: _imports_1
        }, null, -1))
      ], 36))
    : _createCommentVNode("", true)
}
}

})